import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';

import { AssignedPresubscriptionsResolver } from './assigned-presubscriptions-resolver';
import { CancelledPresubscriptionsResolver } from './cancelled-presubscriptions-resolver';
import { PresubscriptionsByNameResolver } from './presubscription-by-name-resolver';
import { PresubscriptionResourceService } from './presubscription-resource.service';
import { PresubscriptionTranslationService } from './presubscription-translation.service';
import { PresubscriptionResolver } from './presubscription.resolver';
import { WaitingListPresubscriptionsResolver } from './waiting-list-presubscriptions-resolver';
import { WaitingPresubscriptionsResolver } from './waiting-presubscriptions-resolver';
import { ApiResourceModule } from '../api-resource/api-resource.module';

@NgModule({
  declarations: [],
  exports: [],
  imports: [CommonModule, ApiResourceModule],
  providers: [
    PresubscriptionResourceService,
    PresubscriptionTranslationService,
    PresubscriptionResolver,
    WaitingPresubscriptionsResolver,
    WaitingListPresubscriptionsResolver,
    AssignedPresubscriptionsResolver,
    CancelledPresubscriptionsResolver,
    PresubscriptionsByNameResolver,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class PresubscriptionResourceModule {}
